import React from 'react';

import { Box, Typography } from '@material-ui/core';
import clsx from 'clsx';

import useStyles from '../styles';

export const RoleCard = ({
  alt,
  src,
  title,
  subTitle,
  reversed,
  onClick,
}: {
  alt: string;
  src: string;
  title: string;
  subTitle: string;
  reversed?: boolean;
  onClick: () => void;
}) => {
  const classes = useStyles();

  return (
    <Box className={clsx(classes.buttonCard, { [classes.reversedButtonCard]: reversed })} onClick={onClick}>
      <Box className={classes.cardImageWrapper}>
        <img width="100%" height="100%" alt={alt} src={src} />
      </Box>

      <Box display="flex" flexDirection="column" justifyContent="center">
        <Typography variant="h6" color="primary">
          {title}
        </Typography>
        <Typography color="primary" variant="subtitle1">
          {subTitle}
        </Typography>
      </Box>
    </Box>
  );
};
